import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useFpCampaignProductsService } from '@cart-services/hooks/useFpCampaignProductsService'
import { type ProjectCode, type CountryCode } from '@constants'
import { useOrder } from '@hooks-api/ec/use-order'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { OrderDetailProvider, type OrderDetailProviderProps } from '@order-detail/components/shared/OrderDetailProvider/OrderDetailProvider'
import { OrderDetail } from '@order-detail/components/shared/Orders/OrderDetail'
import { SkeletonOrderDetail } from '@order-detail/components/shared/Orders/SkeletonOrderDetail'
import { Box } from '@pets-ui/Box/Box'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { LayoutMyAccount } from '@wp-my-account/components/LayoutMyAccount'
import { useParams } from 'react-router-dom-v5'
import { TheCampaignHeader } from '../../components/TheCampaignHeader'
import { useFastpassMenuItems } from '../../hooks/use-fastpass-menu-items'

export function OrderDetailContainer({ countryCode }: { countryCode: CountryCode }) {
  const { transactionId } = useParams<{ transactionId: string }>()
  const { order: { destructuredData: transaction, isLoading: isLoadingOrder } } = useOrder({ transactionId, countryCode })
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const campaignId = exhibitorSettings?.campaign_id ?? undefined
  const { projectCode } = useFpCampaignProductsService(campaignCodeFromUrl)

  const { destructuredData: campaignMember } = useApiCampaignMember({ code: campaignCodeFromUrl })
  const menuItem = useFastpassMenuItems('campaign', campaignCodeFromUrl, campaignMember?.user_name)
  const countryCodeFromOrder = transaction?.country_code
  const isWarehouseOrSubscription = !!transaction?.child_orders[0]?.subship_info?.type
  const orderDetailContextValue: OrderDetailProviderProps = {
    transaction,
    currency: transaction?.currency,
    showRecipientInfo: true,
    countryCode: countryCodeFromOrder,
    isWarehouseOrSubscription,
  }
  return (
    <>
      <OrderDetailProvider {...orderDetailContextValue}>
        <TheCampaignHeader projectCode={projectCode as ProjectCode} campaignId={campaignId as number} countryCode={countryCode} />
        <Box backgroundColor={colors.grey100}>
          <LayoutMyAccount menuItem={menuItem}>
            {isLoadingOrder
              ? <SkeletonOrderDetail />
              : <OrderDetail />}
          </LayoutMyAccount>
        </Box>
      </OrderDetailProvider>
    </>
  )
}
